import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ReferralGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
  color,
  width,
  height,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.text.secondary;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_45084_25368)">
        <path
          d="M9.69171 0.144531C6.90805 0.144531 4.67248 2.05559 4.67248 5.71184C4.67248 8.09886 5.6244 10.5328 7.06671 12.0291C7.62921 13.5255 6.61599 14.0844 6.40325 14.1638C3.48978 15.2311 0.0859375 17.171 0.0859375 19.0965V19.8176C0.0859375 22.4426 5.08353 23.0484 9.72055 23.0484C10.7374 23.0484 11.7578 23.0051 12.7494 22.933C11.5306 21.6421 10.7879 19.915 10.7879 18.0003C10.7879 16.3489 11.3504 14.8308 12.2879 13.6157C12.1472 13.2912 12.0931 12.7791 12.3456 12.0003C13.7806 10.5003 14.7109 8.08804 14.7109 5.71184C14.7109 2.05559 12.4754 0.144531 9.69171 0.144531ZM17.9994 12.1734C14.7831 12.1734 12.1725 14.7803 12.1725 18.0003C12.1725 21.2203 14.7794 23.8272 17.9994 23.8272C21.2194 23.8272 23.8263 21.2203 23.8263 18.0003C23.8263 14.7803 21.2157 12.1734 17.9994 12.1734ZM17.1917 14.7695H18.8071V17.1638H21.2013V18.8368H18.8071V21.2311H17.1917V18.8368H14.7686V17.1638H17.1917V14.7695Z"
          fill="#286AF6"
        />
      </g>
      <defs>
        <clipPath id="clip0_45084_25368">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </CustomSvg>
  );
};

export default ReferralGe;
